export * from './category-container.component'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/categories-agregator/index.ts